var MobileNavigation = /** @class */ (function () {
    function MobileNavigation() {
        this.header = document.querySelector('[data-header]');
        this.mobileMenuToggle = this.header.querySelector('[data-mobile-menu-toggle]');
        this.mobileMenu = this.header.querySelector('[data-mobile-menu]');
        this.firstLevelShowAll = this.mobileMenu.querySelector('.header-mobile-menu-show-all');
        this.firstLevelItems = this.mobileMenu.querySelectorAll('.header-mobile-navigation > .menu-item > a');
        this.bottomNavigationWrapper = this.mobileMenu.querySelector('.header-mobile-menu-bottom');
        this.goBackToggle = this.mobileMenu.querySelector('.header-mobile-menu-back');
        this.languageSwitcherContainer = this.mobileMenu.querySelector('[data-language-menu]');
        this.body = document.body;
        this.pageOverlay = document.querySelector('[data-page-overlay]');
        this.addEventListeners();
    }
    MobileNavigation.prototype.addEventListeners = function () {
        var _this = this;
        this.mobileMenuToggle.addEventListener('click', function () { return _this.toggleNavigation(); });
        window.addEventListener('resize', function () { return _this.destroyMobileNavigation(); });
        this.firstLevelItems.forEach(function (toggle) {
            if (toggle.parentElement.classList.contains('menu-item-has-children')) {
                toggle.addEventListener('click', function (event) { return _this.toggleSubmenu(event); });
            }
        });
        this.goBackToggle.addEventListener('click', function (event) { return _this.closeSubmenu(); });
    };
    MobileNavigation.prototype.toggleSubmenu = function (event) {
        event.preventDefault();
        var toggle = event.currentTarget;
        var toggleParent = toggle.parentElement;
        var submenu = toggleParent.querySelector('.sub-menu');
        var submenuItems = submenu.querySelectorAll('.menu-item');
        var itemUrl = toggle.getAttribute('href');
        var itemTitle = toggle.innerText;
        this.firstLevelShowAll.setAttribute('href', itemUrl);
        this.firstLevelShowAll.setAttribute('title', itemTitle);
        submenuItems.forEach(function (submenuItem) {
            if (submenuItem.classList.contains('menu-item-has-children')) {
                submenu.classList.add('grouped');
            }
        });
        if (!toggleParent.classList.contains('active')) {
            this.firstLevelItems.forEach(function (menuItems) {
                menuItems.parentElement.classList.add('hidden');
            });
            toggleParent.classList.remove('hidden');
            toggleParent.classList.add('active');
            submenu.classList.add('open');
            this.bottomNavigationWrapper.classList.add('active');
            // If item url is not set or empty, hide show all button
            if (itemUrl === '#' || itemUrl === '' || itemUrl === undefined || itemUrl === null) {
                this.firstLevelShowAll.classList.remove('active');
            }
            else {
                this.firstLevelShowAll.classList.add('active');
                // move after toggle element
                toggle.insertAdjacentElement('afterend', this.firstLevelShowAll);
            }
        }
    };
    MobileNavigation.prototype.closeSubmenu = function () {
        this.firstLevelItems.forEach(function (menuItems) {
            menuItems.parentElement.classList.remove('hidden');
            menuItems.parentElement.classList.remove('active');
        });
        this.mobileMenu.querySelectorAll('.sub-menu').forEach(function (submenu) {
            submenu.classList.remove('open');
        });
        this.bottomNavigationWrapper.classList.remove('active');
        this.firstLevelShowAll.classList.remove('active');
    };
    MobileNavigation.prototype.toggleNavigation = function () {
        if (this.mobileMenuToggle.classList.contains('active')) {
            this.closeNavigation();
        }
        else {
            this.body.classList.add('no-scroll');
            this.pageOverlay.classList.add('visible');
            this.header.classList.add('active');
            this.mobileMenuToggle.classList.add('active');
            this.mobileMenu.classList.add('open');
        }
    };
    MobileNavigation.prototype.closeNavigation = function () {
        this.firstLevelItems.forEach(function (menuItems) {
            var _a;
            menuItems.parentElement.classList.remove('hidden');
            menuItems.parentElement.classList.remove('active');
            (_a = menuItems.parentElement.querySelector('.sub-menu')) === null || _a === void 0 ? void 0 : _a.classList.remove('open');
        });
        this.body.classList.remove('no-scroll');
        this.pageOverlay.classList.remove('visible');
        this.header.classList.remove('active');
        this.mobileMenuToggle.classList.remove('active');
        this.mobileMenu.classList.remove('open');
        this.bottomNavigationWrapper.classList.remove('active');
        this.firstLevelShowAll.classList.remove('active');
        this.languageSwitcherContainer.classList.remove('active');
    };
    MobileNavigation.prototype.destroyMobileNavigation = function () {
        var zIndex = getComputedStyle(document.body).zIndex;
        if (zIndex == "3") {
            this.closeNavigation();
        }
    };
    return MobileNavigation;
}());
export default MobileNavigation;
